import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import compact from 'lodash/compact';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Select from 'react-select';
import { isInt } from 'validator';
import { Link } from 'react-router-dom';
import {
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  FormText,
  InputGroup,
  InputGroupAddon,
  Col,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { object, func, array } from 'prop-types';
import ProfileAvatar from './ProfileAvatar';
import TimezoneSelector from './TimezoneSelector';
import TelegramActivationBlock from './TelegramActivationBlock';
import CustomControl from '../CustomControl/CustomControl';
import { defaultLocale, defaultLanguages, defaultTheme } from '../../config';
import SocialsList from '../Socials/SocialsList';

class ProfileEditForm extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    submit: func.isRequired,
    profile: object.isRequired,
    updateProfile: func.isRequired,
    onSavingPhone: func.isRequired,
    themes: array.isRequired,
    languages: array.isRequired,
  };

  static defaultProps = {
    profile: {},
    languages: defaultLanguages,
  };

  constructor(props) {
    super(props);

    const { profile } = props;

    const { visibleAccountFields, visibleAccountInputs } = this.getVisibleAccountFields(
      profile.accounts,
    );

    this.state = {
      upload: false,
      data: {
        img: profile.img ? profile.img : '',
        login: profile.login ? profile.login : '',
        email: profile.email ? profile.email : '',
        phone: profile.phone ? profile.phone : '',
        skype: profile.skype ? profile.skype : '',
        icq: profile.icq ? profile.icq : '',
        not_use_in_stats: profile.not_use_in_stats ? profile.not_use_in_stats : false,
        phone_approved: profile.phone_approved ? profile.phone_approved : false,
        timezone: profile.timezone ? profile.timezone : '',
        language: profile.language ? profile.language : defaultLocale,
        theme: profile.theme ? profile.theme : defaultTheme,
        use_transit_service: profile.use_transit_service ? profile.use_transit_service : false,
        accounts: profile.accounts ? profile.accounts : [],
      },
      validation: {
        login: 'isRequired',
        icq: 'isInt',
      },
      errors: {},
      accountErrors: {},
      isEmailReadOnly: !!profile.email,
      dropdownOpen: false,
      visibleAccountFields,
      visibleAccountInputs,
      visibleAccountFieldIdFocus: null,
    };

    this.$fileInput = React.createRef();
    this.$currentAccountRef = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { profile } = nextProps;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        ...profile,
      },
      isEmailReadOnly: !!profile.email,
    }));
  }

  componentDidUpdate(prevProps, { visibleAccountFieldIdFocus }) {
    const { visibleAccountFieldIdFocus: NEXTvisibleAccountFieldIdFocus } = this.state;
    if (visibleAccountFieldIdFocus !== NEXTvisibleAccountFieldIdFocus) {
      if (this.$currentAccountRef) {
        this.$currentAccountRef.focus();
      }
    }
  }

  getVisibleAccountFields = (accounts = []) => {
    const visibleAccountFields = [];
    const visibleAccountInputs = [];
    accounts.forEach((account) => {
      if (account) {
        if (!account.login) {
          visibleAccountFields.push(account.id);
        } else {
          visibleAccountInputs.push(account.id);
        }
      }
    });
    return {
      visibleAccountFields,
      visibleAccountInputs,
    };
  };

  validate = (fields) => {
    const errors = {};
    const { intl } = this.props;
    const { data, validation } = this.state;

    Object.keys(fields).forEach((field) => {
      switch (validation[field]) {
        case 'isRequired':
          data[field].length === 0 &&
            (errors[field] = intl.formatMessage({
              id: 'profile.error.required',
              defaultMessage: 'This field is required',
            }));
          break;

        case 'isInt':
          !isInt(data[field]) &&
            data[field].length > 0 &&
            (errors[field] = intl.formatMessage({
              id: 'profile.error.number',
              defaultMessage: 'This field must be a number',
            }));
          break;

        default:
          break;
      }
    });

    if (Object.keys(errors).length > 0) {
      return errors;
    }

    return false;
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  onChange = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  onSelectChange = (prop, value) => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [prop]: value,
      },
    }));
  };

  onChangeTimezone = (timezone) => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        timezone,
      },
    }));
  };

  onChangeChecked = ({ target }) => {
    const { name } = target;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [name]: !prevState.data[name],
      },
    }));
  };

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.validation);
    this.setState(() => ({ errors }));

    if (Object.keys(errors).length === 0) {
      this.props.submit(this.prepareData(this.state.data));
    }
  };

  prepareData = (data) => {
    const { accounts, ...rest } = data;
    const preparedData = { ...rest };
    accounts.forEach((account) => {
      preparedData[`accounts[${account.id}]`] = account.login;
    });
    return preparedData;
  };

  handleSavePhone = () => {
    const { phone } = this.state.data;
    const { intl } = this.props;

    if (phone.length === 0) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          phone: intl.formatMessage({
            id: 'profile.error.required',
            defaultMessage: 'This field is required',
          }),
        },
      }));
    } else if (phone.length <= 10) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          phone: intl.formatMessage({
            id: 'profile.error.invalid-number',
            defaultMessage: 'Invalid number. Try to enter number with country code.',
          }),
        },
      }));
    } else {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          phone: '',
        },
      }));
      this.props.onSavingPhone(phone);
    }
  };

  handleFileUpload = () => {
    this.props.updateProfile({ isAvatarUpdate: true });
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  onAccountChange = (e) => {
    const { target } = e;

    this.setState((prevState) => {
      const fieldsIndex = prevState.data.accounts.findIndex(({ title }) => title === target.name);
      const newAccounts = [...prevState.data.accounts];
      if (fieldsIndex >= 0) {
        newAccounts[fieldsIndex] = {
          ...newAccounts[fieldsIndex],
          login: target.value,
        };
      }
      return {
        data: {
          ...prevState.data,
          accounts: newAccounts,
        },
      };
    });
  };

  handleAdditionalContactClick = (id) => {
    this.setState((prevState) => ({
      visibleAccountFields: compact(
        prevState.visibleAccountFields.filter((fieldId) => fieldId !== id),
      ),
      visibleAccountInputs: compact([...prevState.visibleAccountInputs, id]),
      visibleAccountFieldIdFocus: id,
    }));
  };

  render() {
    const {
      img,
      login,
      email,
      phone,
      skype,
      not_use_in_stats,
      phone_approved,
      timezone,
      language,
      theme,
      use_transit_service,
    } = this.state.data;

    const {
      errors,
      isEmailReadOnly,
      dropdownOpen,
      data,
      visibleAccountFields,
      visibleAccountInputs,
    } = this.state;
    const { languages, themes, timezones, socials, accounts, handleUnsubscribe } = this.props;
    const {
      telegramActivationCode,
      telegramBotLink,
      isTelegramConnected,
      notifications,
      onChangeNotification,
    } = this.props;

    return (
      <Form onSubmit={this.onSubmit} autoComplete="off" className="profile-edit-form">
        <div className="profile-edit-form-container">
          <div className="profile-edit-form-wrapper">
            <h6 className="profile-edit-form-title">
              <FormattedMessage id="profile.info-title" defaultMessage="General information" />
            </h6>

            <div className="profile-edit-form-fields">
              <ProfileAvatar avatar={img} error={errors.img} onFileUpload={this.handleFileUpload} />
              <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.login })}>
                <Label htmlFor="name">
                  <FormattedMessage id="profile.name" defaultMessage="Name" />
                </Label>
                <Input id="name" type="text" name="login" value={login} onChange={this.onChange} />
                {errors.login && <small className="form-text">{errors.login}</small>}
              </FormGroup>
              <FormGroup className="form-group-upper-label">
                <Label htmlFor="email">
                  <FormattedMessage id="profile.email" defaultMessage="E-mail" />
                </Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  readOnly={isEmailReadOnly}
                  onChange={(e) => (isEmailReadOnly ? false : this.onChange(e))}
                />
                {isEmailReadOnly && (
                  <FormText>
                    <FormattedMessage
                      id="profile.change_possible"
                      defaultMessage="Change is possible only on request to the"
                    />{' '}
                    <Link to="/tickets/create">
                      <FormattedMessage id="profile.support" defaultMessage="support" />
                    </Link>
                  </FormText>
                )}
              </FormGroup>
            </div>
          </div>

          <div className="profile-edit-form-wrapper transparent">
            <div className="profile-edit-form-wrapper">
              <h6 className="profile-edit-form-title">
                <FormattedMessage id="profile.contacts-title" defaultMessage="Contacts" />
              </h6>
              {data.accounts
                .filter((field) => field.title !== 'webmasters.ru')
                .map((field, index) => {
                  const accountError = this.props.accountErrors?.[field.id];
                  return (
                    <FormGroup key={`profile-field-${field.id}`} className="form-group-upper-label">
                      <Label htmlFor={field.title}>{field.title}</Label>
                      <Input
                        innerRef={
                          field.id === this.state.visibleAccountFieldIdFocus
                            ? this.$currentAccountRef
                            : null
                        }
                        id={field.title}
                        type="text"
                        name={field.title}
                        value={field.login === null ? '' : field.login}
                        onChange={this.onAccountChange}
                      />
                      {accountError && <small className="form-error">{accountError}</small>}
                    </FormGroup>
                  );
                })}
            </div>
          </div>
        </div>

        <div className="profile-edit-form-container">
          <div className="profile-edit-form-wrapper transparent">
            <div className="profile-edit-form-wrapper">
              <TelegramActivationBlock
                activationCode={telegramActivationCode}
                botLink={telegramBotLink}
                isTelegramConnected={isTelegramConnected}
                notifications={notifications}
                onChange={onChangeNotification}
              />
            </div>
          </div>
        </div>

        <div className="profile-edit-form-container">
          <div className="profile-edit-form-wrapper transparent">
            <div className="profile-edit-form-wrapper">
              <h6 className="profile-edit-form-title">
                <FormattedMessage id="profile.timezone-title" defaultMessage="Timezone" />
              </h6>

              <TimezoneSelector
                timezones={timezones}
                selected={timezone}
                error={errors.timezone}
                onChangeTimezone={this.onChangeTimezone}
              />

              <FormGroup className="form-group-upper-label profile-edit-form-fields">
                <Label htmlFor="language">
                  <FormattedMessage id="profile.language" defaultMessage="Language" />
                </Label>
                <Select
                  id="language"
                  name="language"
                  clearable={false}
                  value={language}
                  onChange={({ value }) => this.onSelectChange('language', value)}
                  options={languages.map((lang) => ({
                    value: lang.key,
                    label: lang.title,
                  }))}
                />
              </FormGroup>
            </div>

            <div className="profile-edit-form-wrapper">
              <h6 className="profile-edit-form-title">
                <FormattedMessage id="profile.privacy-title" defaultMessage="Privacy" />
              </h6>

              <FormGroup>
                <ul className="profile-extra-settings list-unstyled no-margin">
                  <li>
                    <CustomControl
                      id="not_use_in_stats"
                      name="not_use_in_stats"
                      className="custom-control-xs"
                      onChange={this.onChangeChecked}
                      checked={not_use_in_stats}
                      value="1"
                    >
                      <FormattedMessage
                        id="profile.dont_use_statistics"
                        defaultMessage="Do not use my data in statistics"
                      />
                    </CustomControl>
                  </li>
                </ul>
              </FormGroup>
            </div>
          </div>
        </div>

        <div className="profile-buttons-wrapper">
          <Button color="primary">
            <FormattedMessage id="profile.save" defaultMessage="Save" />
          </Button>
        </div>
      </Form>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  languages: app.globalSettings.languages,
  themes: app.globalSettings.themes,
});

export default connect(mapStateToProps)(injectIntl(ProfileEditForm));
